module.exports = __webpack_public_path__ + "static/social-media-67278dd10e8e209541f60f11a4ecf467.jpg";